import localitiesData from "./localities.json";
import zonesData from "./zones.json";
import provincesData from "./provinces.json";
import type { LocalityRecord, ZoneRecord, ProvinceRecord } from "../types";

export const localities = localitiesData.localities as LocalityRecord[];
export const zones = zonesData.zones as ZoneRecord[];
export const provinces = provincesData.provinces as ProvinceRecord[];

export const dataVersion = {
  localities: localitiesData.version,
  zones: zonesData.version,
  provinces: provincesData.version,
  last_updated: localitiesData.last_updated,
};
